import {
  drawerSlotRecipe
} from "./chunk-CKXMD6H2.mjs";
import {
  createStyleContext
} from "./chunk-7AJJGGQG.mjs";

// src/components/drawer/styled-components.ts
import * as Dialog from "@radix-ui/react-dialog";
var { withContext, withProvider } = createStyleContext(drawerSlotRecipe);
var Root2 = withProvider(Dialog.Root, "root");
var Overlay2 = withContext(Dialog.Overlay, "overlay");
var Content2 = withContext(Dialog.Content, "content");
var Header = withContext("div", "header");
var Title2 = withContext(Dialog.Title, "title");
var Body = withContext("div", "body");
var Footer = withContext("div", "footer");
var StyledDrawer = Object.assign(Root2, {
  Overlay: Overlay2,
  Content: Content2,
  Header,
  Title: Title2,
  Body,
  Footer
});

export {
  StyledDrawer
};
